
import { StepProps } from './OnboardingStep';

export const steps: StepProps[] = [
  // Step 1: Add a group
  {
    title: "Add a Group",
    description: "Start by creating a group called 'Work 💻' to organize your notes.",
    targetElement: "button:has(.h-4.w-4.mr-2)",
    page: 'home',
    position: 'bottom',
    offset: { x: 0, y: 10 },
  },
  
  // Step 2: Text editor icon
  {
    title: "Create a New Note",
    description: "Click the text editor icon to create your first note.",
    targetElement: "button:has(.PlusSquare)",
    page: 'home',
    position: 'bottom',
    offset: { x: 0, y: 10 },
  },
  
  // Step 3: Upload cover image
  {
    title: "Add a Cover Image",
    description: "Enhance your note with a beautiful cover image.",
    targetElement: "button:has(.w-8.h-8)",
    page: 'editor',
    position: 'top',
    animation: {
      type: 'highlight',
    },
  },
  
  // Step 4: Add a title
  {
    title: "Add a Title",
    description: "Give your note a meaningful title.",
    targetElement: "input.text-lg",
    page: 'editor',
    position: 'bottom',
    animation: {
      type: 'type',
      text: "Writing my first note",
      color: '#F2FCE2',
    },
  },
  
  // Step 5: Start writing a note
  {
    title: "Start Writing",
    description: "Write down your thoughts and ideas in your note.",
    targetElement: "textarea.min-h-\\[200px\\]",
    page: 'editor',
    position: 'top',
    animation: {
      type: 'type',
      text: "Today I learned about MindNote, a great tool for writing.",
      color: '#F2FCE2',
    },
  },
  
  // Step 6: AI assistance
  {
    title: "Use AI Assistance",
    description: "Try: \"Keep the same list and add 20 more EU countries\", \"Keep the same list and correct grammar\", or \"translate this text to Spanish\".",
    targetElement: "input[placeholder*='Enter instruction']",
    page: 'editor',
    position: 'top',
    animation: {
      type: 'type',
      text: "Keep the same list and add 20 more EU countries",
      showProcessButton: true,
    },
  },
  
  // Step 7: Select group
  {
    title: "Select a Group",
    description: "Assign your note to a group for better organization.",
    targetElement: "div.flex.justify-between.items-center.mt-4 button:first-child",
    page: 'editor',
    position: 'bottom',
  },
  
  // Step 8: Use tools
  {
    title: "Customize Your Note",
    description: "Use these tools to change note color, add comments, export, and more.",
    targetElement: "div.fixed.bottom-0.inset-x-0",
    page: 'editor',
    position: 'top',
    offset: { x: 0, y: -20 },
    width: 350,
  },
  
  // Step 9: Save note
  {
    title: "Save Your Note",
    description: "Click the Save Note button to store your note securely.",
    targetElement: "button[data-tour='save-note']",
    page: 'editor',
    position: 'left',
  },
];
